module.exports = __webpack_public_path__ + "img/收缩.57a7f2c1.svg";